import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { TimezoneService } from '@services/timezone.service';
import { isSameDay } from 'date-fns';
import moment from 'moment-timezone';

@Pipe({
  name: 'userTimezoneRangeDate',
})
export class UserTimezoneRangeDatePipe implements PipeTransform {
  private userTimezone: string;

  constructor(
    @Inject(LOCALE_ID) readonly locale: string,
    private readonly datePipe: DatePipe,
    private readonly timezoneService: TimezoneService,
  ) {
    this.timezoneService.timezone.subscribe((tz) => (this.userTimezone = tz));
  }

  transform(dateFrom: string | number | Date, dateTo: string | number | Date, format = 'dd.MM.yyyy'): string {
    if (dateFrom && dateTo && this.userTimezone) {
      const dateFromFormatted = moment.utc(dateFrom).tz(this.userTimezone).format('YYYY-MM-DD HH:mm:ss');
      const dateDoFormatted = moment.utc(dateTo).tz(this.userTimezone).format('YYYY-MM-DD HH:mm:ss');
      return isSameDay(new Date(dateFromFormatted), new Date(dateDoFormatted))
        ? `${this.datePipe.transform(dateFromFormatted, format, '', this.locale)}, ${this.datePipe.transform(
            dateFromFormatted,
            'shortTime',
            '',
            this.locale,
          )} – ${this.datePipe.transform(dateDoFormatted, 'shortTime', '', this.locale)}`
        : `${this.datePipe.transform(dateFromFormatted, 'short', '', this.locale)} – ${this.datePipe.transform(
            dateDoFormatted,
            'short',
            '',
            this.locale,
          )}`;
    }
    return '';
  }
}
